module.exports = __webpack_public_path__ + "static/media/graphql.a7f48025.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/graphql.png
// module id = 1764
// module chunks = 0